import React, { Fragment,useState } from "react";
import { Row, Col, Form, Button, ListGroup } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';

import { FaMapMarkerAlt, FaEnvelope, FaMobileAlt } from "react-icons/fa";
import {SEND_QUERY_DATA} from '../Actions/ApiUrls';
import Axios from "../Actions/Axios"

const GetInTouch = (props) => {
  const data= props.data;
  const [input,setInput]= useState({name:"",email:'', subject:'', message:''})

  const handleChange=(e)=>{
    e.preventDefault();
    setInput({...input, [e.target.name]:e.target.value})
  }

  const sendMail=(e)=>{
    e.preventDefault();
    
    Axios.post(SEND_QUERY_DATA,input)
    .then(res=>{
      
      res=res.data;
      if(res.status){
        toast.success(res.message)
      }
    })
    .catch(err=>{
      console.log(err,7878)
    })
  }
  return (
    <section id="getInTouch">
      <Row>
        <Col>
          <h3 className="section-title">{data.getInTouchtitle || ''}</h3>
          <p>{data.getInTouchSubTitle || ''}</p>
        </Col>
      </Row>
      <Row className="getTouch-form">
        <Col md={6}>
          <Form method='post' onSubmit={(e)=>sendMail(e)}>
            <Form.Row  >
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Control type="text" placeholder="Enter name" required name='name' value={input.name} onChange={handleChange} />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridPassword">
                <Form.Control type="email" placeholder="Enter email" required name='email' value={input.email} onChange={handleChange} />
              </Form.Group>
            </Form.Row>

            <Form.Group controlId="formGridAddress1">
              <Form.Control type="text" placeholder="Subject" required name='subject' value={input.subject} onChange={handleChange} />
            </Form.Group>

            <Form.Group controlId="exampleForm.ControlTextarea1" >
              <Form.Control
                as="textarea"
                rows="3"
                placeholder="write you message here"
                name='message' 
                required
                value={input.message}
                 onChange={handleChange} 
              />
            </Form.Group>
            <Button variant="warning" className='order-btn' type="submit">
              {data.downloadTxt || 'Submit'}
            </Button>
          </Form>
          <ToastContainer />
        </Col>
        
        <Col style={{padding: 25}}>
       <iframe src={data.location} style={{width:'100%',height:'240px',border:0}} frameborder="0"  allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        
        </Col>
      </Row>
    </section>
  );
};

export default GetInTouch;
